import { MINIMUN_TO_VALIDADE, SAME_AMOUNT, MISSING, VALID } from '@constants'

function getPatternReturn(status = VALID, msg = '') {
	return {
		status: status,
		msg: msg,
	}
}

function getValues(seats) {
	let strech = {}

	seats.forEach((seat) => {
		let trip = `${seat.originId}-${seat.destinationId}`

		if (!strech[trip]) {
			strech[trip] = []
		}
		strech[trip].push(seat)
	})

	return Object.values(strech)
}

function compareQttSeats(values, currentStep, isRebooking) {
	let previous = 0
	let current = 0
	let result = getPatternReturn()

	let valuesSorted = values.sort().reverse()

	if (valuesSorted.length < currentStep) {
		return result
	}

	if (isRebooking && valuesSorted.length) {
		result = getPatternReturn(
			SAME_AMOUNT,
			`Você não pode remarcar mais do que uma poltrona por vez.`
		)
	}

	valuesSorted.forEach((qtt, idx) => {
		if (idx == 0) {
			previous = qtt.length
		} else {
			current = qtt.length

			if (previous == current || isRebooking) {
				result = getPatternReturn(
					SAME_AMOUNT,
					`Você não pode selecionar mais do que ${current} poltrona${
						current > 1 ? 's' : ''
					}`
				)
			} else if (previous > current) {
				let diff = previous - current
				result = getPatternReturn(
					MISSING,
					`Você precisa selecionar mais ${diff} poltrona${
						diff > 1 ? 's' : ''
					}`
				)
			}

			previous = current
		}
	})

	return result
}

export function validateQttSeats(
	seatsGoing,
	seatsReturn,
	currentStep,
	isRebooking
) {
	let result = getPatternReturn()

	let arrayValues = getValues([...seatsGoing, ...seatsReturn])

	if (arrayValues.length >= MINIMUN_TO_VALIDADE) {
		result = compareQttSeats(arrayValues, currentStep, isRebooking)
	}

	return result
}
